import React, { useState } from 'react';
import { Tooltip as ChakraTooltip, Box } from '@chakra-ui/react';
import { IconInfo } from 'components/Icons';

type TooltipProps = {
  label: string | JSX.Element;
  icon?: JSX.Element;
};

export const Tooltip = ({ label, icon }: TooltipProps): JSX.Element => {
  const [infoHovered, setInfoHovered] = useState(false);
  return (
    <ChakraTooltip
      bg="bg-default"
      color="font-light"
      fontSize={15}
      fontWeight={400}
      padding="20px 25px 25px"
      boxShadow=" 0 1px 3px 0 rgba(0, 0, 0, 0.06), 0 8px 20px 0 rgba(0, 0, 0, 0.15)"
      label={label}
    >
      <Box pt={1}>
        {icon ? (
          icon
        ) : (
          <IconInfo
            color={infoHovered ? '#0091eb' : '#d6dbde'}
            cursor="pointer"
            onMouseEnter={(): void => setInfoHovered(!infoHovered)}
            onMouseLeave={(): void => setInfoHovered(!infoHovered)}
          />
        )}
      </Box>
    </ChakraTooltip>
  );
};
